import React, { Component } from "react";
import { Container } from "react-bootstrap";
import PostApiCall from "../Helper/PostApi";
import "./Categorycomponent.css";

export default class MobileProductCategoryCard2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      DestinationData: [],
    };
  }

  componentDidMount() {
    localStorage.removeItem("DepartureData");

    PostApiCall.postRequest({ WhereClause: `` }, "GetPackageMaster").then(
      (resultdes) =>
        resultdes.json().then((obj) => {
          this.setState({
            DestinationData: obj.data,
          });
        })
    );
  }
  render() {
    return (
      <Container className="my-5 phncardmainparentpadding">
        <h1 className="sectionheading topdestinationphnheading comonfontfamilynew">
          Experiential Holidays
        </h1>
        <div className="sectionborder"></div>

        {this.state.DestinationData.map((item, i) => {
          return (
            <div
              className="position-relative cardhovereffect"
              style={{ width: "100%", marginRight: "auto !importnat" }}
            >
              <p className="tour-date">{item.fld_total_days}</p>
              <a
                href={`${
                  process.env.PUBLIC_URL
                }/destinationdetail/${item.fld_display_url.replace(
                  /\s/g,
                  "-"
                )}/${item.fld_id}`}
              >
                <article
                  className="tour-card"
                  style={{ width: "100%", height: "95%" }}
                  key={i}
                >
                  <div className="tour-img-container">
                    {" "}
                    <img
                      src={item.fld_banner}
                      className="tour-img"
                      alt=""
                      style={{ height: "150px" }}
                    />
                  </div>
                  <div className="tour-info tour_infopadding">
                    <div className="tour-title">
                      <b className="fw-bolder fs md-3 homecardplacename">
                        {item.fld_destination_name}
                      </b>
                    </div>
                    {item.fld_price != null && (
                      <h4
                        className="fw-bold text-secondary"
                        style={{ fontSize: "18px" }}
                      >
                        ₹ {item.fld_price}
                      </h4>
                    )}
                  </div>
                </article>
              </a>
            </div>
          );
        })}
      </Container>
    );
  }
}
